export const VerificationCodeText =
  "We've sent you a verification code to your new email address, please enter it here.";
